import React from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Target, Users, TrendingUp, CheckCircle2, Calendar, MessageCircle, GraduationCap, Award, Briefcase, Eye, Recycle, ArrowRight, Sparkles, BarChart3, Heart } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
export function ImpactPage() {
  return <Layout data-id="element-1406" data-mp="21oyblboum93v">
      <SEO {...pageSEO.impact} data-id="element-1407" data-mp="21pgcilmghbi4" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-1408" data-mp="21m2d9m939iew">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1409" data-mp="1msfuxaxzawxd">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-4" data-id="element-1410" data-mp="1rpfrmv8xunbt">
            Une association naissante, des ambitions concrètes
          </span>
          <h1 className="text-4xl font-bold mb-4" data-id="element-1411" data-mp="3m3h0m8y7cqpm">Notre Vision d'Impact</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-1412" data-mp="1kv0y0k8jpvgy">
            L'ADCC construit son impact pas à pas, avec transparence et rigueur.
            Découvrez notre point de départ, nos objectifs 2026 et comment nous
            mesurerons notre réussite.
          </p>
        </div>
      </div>

      {/* Notre Point de Départ - Le Forum Fondateur */}
      <section className="py-20 bg-white" data-id="element-1413" data-mp="11wydahn16koy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1414" data-mp="11xzr2tvfllad">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1415" data-mp="wyn2o4oww65o">
            <div data-id="element-1416" data-mp="1axwl7b0lbcct">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-1417" data-mp="1ayedxxo1n8fz">
                NOTRE POINT DE DÉPART
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6" data-id="element-1418" data-mp="16uzyp97xiw3l">
                Le Forum Fondateur
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" dangerouslySetInnerHTML={{
              __html: "Nos premiers pas ont été marqués par un <strong>forum d'état des lieux</strong>, qui a réuni une dizaine de personnels de maison de différents domaines pour cartographier leurs besoins et aspirations."
            }} data-id="element-1419" data-mp="2ibq3qp0m9hvm" />

              <div className="bg-amber-50/50 rounded-r-xl p-6 border-l-4 border-amber-400 mb-8" data-id="element-1420" data-mp="1t0lisk2f3u7b">
                <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-1421" data-mp="waudrqwi2on9">
                  <MessageCircle className="w-5 h-5 text-amber-500" data-id="element-1422" data-mp="118mg7eurtt5p" />
                  Ce que nous avons appris
                </h3>
                <ul className="space-y-3" data-id="element-1423" data-mp="159xyezbbfc3v">
                  <li className="flex items-start gap-3" data-id="element-1424" data-mp="1a1fvhca7wsjk">
                    <CheckCircle2 className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-1425" data-mp="1a30rz7g3elk2" />
                    <span className="text-gray-700" data-id="element-1426" data-mp="dis3qyed66lz">
                      Un besoin réel en compétences professionnelles
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1427" data-mp="a25ml76fxuun">
                    <CheckCircle2 className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-1428" data-mp="9zjft9rdjjdh" />
                    <span className="text-gray-700" data-id="element-1429" data-mp="50gcpuuyfn85">
                      Une demande forte de reconnaissance et de dignité
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1430" data-mp="3s6h2pzxbf7dr">
                    <CheckCircle2 className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-1431" data-mp="3n7w2w1lz6ppu" />
                    <span className="text-gray-700" data-id="element-1432" data-mp="3ihfks477mfx5">
                      L'importance d'un accompagnement vers l'emploi structuré
                    </span>
                  </li>
                </ul>
              </div>

              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1433" data-mp="39hk6hqicy4sw">
                Ce forum a posé les bases de notre approche :{' '}
                <strong data-id="element-1434" data-mp="34h4scwq94t9v">écouter d'abord, agir ensuite</strong>. Chaque action de
                l'ADCC est construite à partir des besoins réels exprimés par
                les premiers concernés.
              </p>
            </div>
            <div className="relative" data-id="element-1435" data-mp="18ejnxc7nfrkq">
              <img src="https://cdn.magicpatterns.com/uploads/exRoSvgKroC4rrK6KpbESt/WhatsApp_Image_2026-01-29_at_17.21.09.jpg" alt="Forum fondateur ADCC" className="relative rounded-2xl shadow-xl w-full object-cover h-[400px]" data-id="element-1436" data-mp="18dhz84xpn6kj" />
              {/* Forum Fondateur Badge */}
              <div className="absolute bottom-4 right-4 bg-white rounded-xl px-4 py-3 shadow-lg flex items-center gap-3" data-id="element-1437" data-mp="knnr20oc666m">
                <div className="p-2 bg-blue-50 rounded-full" data-id="element-1438" data-mp="aqre9iremxw9">
                  <Calendar className="w-5 h-5 text-[#1E88E5]" data-id="element-1439" data-mp="asc979hmsiun" />
                </div>
                <div data-id="element-1440" data-mp="fqnjflbu8vde">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-1441" data-mp="fq484ngp158c">
                    Forum Fondateur
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1442" data-mp="2a3vg7ijdjh1o">2024 • Bénin</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Objectifs 2026 */}
      <section className="py-20 bg-gray-50" data-id="element-1443" data-mp="3pmup8kz0czur">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1444" data-mp="3po5t0ksge7lv">
          <div className="text-center mb-16" data-id="element-1445" data-mp="86v1v33hhmni">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-1446" data-mp="87o01fodn3u1">
              CAP SUR 2026
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4" data-id="element-1447" data-mp="h6rjikrghl92">
              Nos Objectifs Chiffrés
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1448" data-mp="c6ww4r6w3dsr">
              Des ambitions réalistes et mesurables pour notre première année
              d'activité pleine.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-1449" data-mp="m6noonbw3iq7">
            <Card className="text-center border-t-4 border-t-[#1E88E5] bg-white" data-id="element-1450" data-mp="2svsjy1yut4oc">
              <CardContent className="pt-8 pb-6" data-id="element-1451" data-mp="2nxr37nowhhg1">
                <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-4" data-id="element-1452" data-mp="2nzbv15jtyma7">
                  <GraduationCap className="w-8 h-8 text-[#1E88E5]" data-id="element-1453" data-mp="3dnfzecwlxaw4" />
                </div>
                <p className="text-5xl font-bold text-[#1E88E5] mb-2" data-id="element-1454" data-mp="3hni0okyfk2av">100</p>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1455" data-mp="3ml9ujkimxyhp">
                  Personnes à accompagner
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-1456" data-mp="3rjb85pxal5ls">
                  Via nos ateliers de Mars 2026 et sessions complémentaires
                </p>
              </CardContent>
            </Card>

            <Card className="text-center border-t-4 border-t-green-500 bg-white" data-id="element-1457" data-mp="4eln3o044z8v">
              <CardContent className="pt-8 pb-6" data-id="element-1458" data-mp="97y9drhbktyg">
                <div className="inline-flex items-center justify-center p-4 bg-green-50 rounded-full mb-4" data-id="element-1459" data-mp="e68646ip02m6">
                  <Briefcase className="w-8 h-8 text-green-600" data-id="element-1460" data-mp="j649c3jkfq0o" />
                </div>
                <p className="text-5xl font-bold text-green-600 mb-2" data-id="element-1461" data-mp="o4fjyghoq4jy">60%</p>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1462" data-mp="o2b6p7xwbt70">
                  Taux de placement visé
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-1463" data-mp="23n3phyjfwccb">
                  Des bénéficiaires accompagnés insérés professionnellement
                </p>
              </CardContent>
            </Card>

            <Card className="text-center border-t-4 border-t-purple-500 bg-white" data-id="element-1464" data-mp="1tpz0zs24g4sc">
              <CardContent className="pt-8 pb-6" data-id="element-1465" data-mp="2rd7r60d2i20o">
                <div className="inline-flex items-center justify-center p-4 bg-purple-50 rounded-full mb-4" data-id="element-1466" data-mp="2rbwhjjwxy01n">
                  <Heart className="w-8 h-8 text-purple-600" data-id="element-1467" data-mp="2mewk1xe5q5m5" />
                </div>
                <p className="text-5xl font-bold text-purple-600 mb-2" data-id="element-1468" data-mp="2hm3e566ycr8h">100%</p>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1469" data-mp="2cp36wryd9ifs">
                  D'insertion éthique
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-1470" data-mp="3a5a0eqndqg0w">
                  Transparents et respectueux des droits
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Pourquoi ces objectifs ? */}
          <div className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm flex flex-col md:flex-row items-start gap-4 mb-16" data-id="element-1471" data-mp="2ig4artdem8di">
            <div className="p-3 bg-blue-50 rounded-full flex-shrink-0" data-id="element-1472" data-mp="24pit27zos4h7">
              <Target className="w-6 h-6 text-[#1E88E5]" data-id="element-1473" data-mp="29nkjxf3ct838" />
            </div>
            <div data-id="element-1474" data-mp="29lpupol1uttc">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1475" data-mp="2xdetnnsdmgj9">
                Pourquoi ces objectifs ?
              </h3>
              <p className="text-gray-600" data-id="element-1476" data-mp="31f9t0mqqyjue">
                Ces chiffres sont ambitieux mais réalistes pour une première
                année. Nous préférons des objectifs atteignables que nous
                pourrons dépasser, plutôt que des promesses impossibles à tenir.
                La crédibilité se construit dans la durée.
              </p>
            </div>
          </div>

          {/* Process Flow */}
          <div className="mt-16" data-id="element-1477" data-mp="1gzy51aooeh12">
            <div className="text-center mb-10" data-id="element-1478" data-mp="1gwsgpxnvfj6e">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-1479" data-mp="19ekv99hhc1gh">
                NOTRE APPROCHE
              </span>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mt-2" data-id="element-1480" data-mp="14inh99tov76v">
                La Chaîne de Valeur ADCC
              </h3>
              <p className="text-gray-600 mt-2 max-w-2xl mx-auto" data-id="element-1481" data-mp="1dgzcxq9ewv66">
                Une approche complète, de la montée en compétences à l'emploi
                durable, pour un impact réel et mesurable.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 relative z-10" data-id="element-1482" data-mp="lrw9gcpcnoul">
              {[{
              icon: GraduationCap,
              title: 'Développer',
              desc: 'Compétences techniques et humaines',
              color: 'bg-blue-50',
              iconColor: 'text-blue-600'
            }, {
              icon: Award,
              title: 'Tester',
              desc: 'Validation et professionnalisation',
              color: 'bg-green-50',
              iconColor: 'text-green-600'
            }, {
              icon: Briefcase,
              title: 'Insérer',
              desc: 'Mise en relation avec employeurs',
              color: 'bg-purple-50',
              iconColor: 'text-purple-600'
            }, {
              icon: Eye,
              title: 'Suivre',
              desc: 'Accompagnement post-placement',
              color: 'bg-amber-50',
              iconColor: 'text-amber-600'
            }, {
              icon: Recycle,
              title: 'Recycler',
              desc: 'Mise à jour des compétences',
              color: 'bg-teal-50',
              iconColor: 'text-teal-600'
            }].map((step, index) => <Card key={index} className="bg-white border-none shadow-md hover:shadow-lg transition-shadow relative" data-id="element-1483" data-mp="2ffj8d9167fg9" data-mpi={index}>
                  <CardContent className="p-6 text-center" data-id="element-1484" data-mp="zso3ualibpc1">
                    <div className={`w-12 h-12 mx-auto rounded-full ${step.color} flex items-center justify-center mb-4`} data-id="element-1485" data-mp="13vkos7yirxj5">
                      <step.icon className={`w-6 h-6 ${step.iconColor}`} data-id="element-1486" data-mp="18sje8d78ngb0" />
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-1487" data-mp="c2trrv90i4su">
                      {step.title}
                    </h4>
                    <p className="text-xs text-gray-600" data-id="element-1488" data-mp="l4t6ggwk0wsm">{step.desc}</p>
                  </CardContent>
                </Card>)}
            </div>

            {/* Engagement Banner */}
            <div className="mt-12 bg-[#1E88E5] rounded-xl p-8 text-center text-white shadow-lg flex flex-col items-center justify-center gap-4" data-id="element-1489" data-mp="3oml7ekso4r2y">
              <Sparkles className="w-8 h-8 text-yellow-300" data-id="element-1490" data-mp="3tjbl51h03al7" />
              <p className="text-xl md:text-2xl font-bold" data-id="element-1491" data-mp="10pusk50yacao">
                "Notre engagement : transformer les compétences en opportunités
                d'emploi durables."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mesure de l'Impact */}
      <section className="py-20 bg-white" data-id="element-1492" data-mp="15gurfftmr4ft">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1493" data-mp="15hwbg9smj19o">
          <div className="text-center mb-16" data-id="element-1494" data-mp="hr0gj3svfpy7">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-1495" data-mp="htwdaoszg8l2">
              Transparence & Rigueur
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4" data-id="element-1496" data-mp="qsqgwz4qdz84">
              Comment nous mesurerons notre impact
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1497" data-mp="lvhzj0repz7x">
              Des indicateurs clairs pour évaluer notre réussite et rendre
              compte à nos partenaires et bénéficiaires.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1498" data-mp="25pt5pxhyvnbr">
            {[{
            icon: Users,
            title: 'Nombre de bénéficiaires accompagnés',
            desc: 'Comptabilisation des participants ayant complété nos programmes de formation',
            target: 'Objectif 2026 : 100 personnes'
          }, {
            icon: Briefcase,
            title: "Taux d'insertion professionnelle",
            desc: 'Pourcentage de bénéficiaires de nos ateliers ayant trouvé un emploi dans les 6 mois',
            target: 'Objectif 2026 : 60%'
          }, {
            icon: TrendingUp,
            title: 'Durabilité des placements',
            desc: 'Suivi à 6 et 12 mois pour mesurer la stabilité des emplois obtenus',
            target: 'Suivi systématique prévu'
          }, {
            icon: BarChart3,
            title: 'Satisfaction des bénéficiaires',
            desc: 'Enquêtes régulières auprès des personnes formées et placées',
            target: 'Questionnaires post-formation et post-placement'
          }].map((metric, index) => <Card key={index} className="bg-white" data-id="element-1499" data-mp="1ejx72a4xavfk" data-mpi={index}>
                <CardContent className="p-6" data-id="element-1500" data-mp="19k166jrivk48">
                  <div className="flex items-start gap-4" data-id="element-1501" data-mp="19lcgl2fh3q4b">
                    <div className="p-3 bg-blue-50 rounded-lg text-[#1E88E5]" data-id="element-1502" data-mp="277jmcfnijoi9">
                      <metric.icon className="w-6 h-6" data-id="element-1503" data-mp="279mdj30ejnok" />
                    </div>
                    <div data-id="element-1504" data-mp="22at87xv9r2zh">
                      <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1505" data-mp="1xhzzkywojai4">
                        {metric.title}
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-1506" data-mp="1si3xj57jlt57">{metric.desc}</p>
                      <div className="inline-flex items-center gap-2 px-3 py-1 bg-gray-100 rounded-full text-sm font-medium text-gray-700" data-id="element-1507" data-mp="2pyszcywhsvel">
                        <Target className="w-4 h-4 text-[#1E88E5]" data-id="element-1508" data-mp="2l5zp5vi98uv4" />
                        {metric.target}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>)}
          </div>

          {/* Rendez-vous fin 2026 */}
          <div className="mt-12 bg-orange-50 border border-orange-100 rounded-xl p-6 flex flex-col md:flex-row items-start gap-4" data-id="element-1509" data-mp="32fljhi2hmoqu">
            <div className="p-3 bg-orange-100 rounded-full flex-shrink-0" data-id="element-1510" data-mp="3bhl0iadi5sts">
              <Calendar className="w-6 h-6 text-orange-600" data-id="element-1511" data-mp="3bfies2jduluv" />
            </div>
            <div data-id="element-1512" data-mp="3gf3dcbun4s72">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1513" data-mp="3gel84pq033n0">
                Rendez-vous fin 2026
              </h3>
              <p className="text-gray-600" data-id="element-1514" data-mp="3q6hhiwxjeg6j">
                Nous publierons notre premier rapport d'impact fin 2026, avec
                les données réelles et vérifiables. D'ici là, suivez notre
                actualité sur notre blog et nos réseaux sociaux pour des mises à
                jour régulières sur nos avancées.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#2C3E50] text-white" data-id="element-1515" data-mp="1v4426hxessqh">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1516" data-mp="1v1htug2p2977">
          <h2 className="text-3xl font-bold mb-6" data-id="element-1517" data-mp="28w0qeavyiihl">Participez à notre impact</h2>
          <p className="text-xl text-gray-300 mb-10" data-id="element-1518" data-mp="2437m1o4ehc61">
            Votre soutien est essentiel pour nous aider à atteindre nos
            objectifs et transformer la vie de nos bénéficiaires.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1519" data-mp="2dt0z6tk6xzce">
            <Link to="/donate" data-id="element-1520" data-mp="2rtv8def2c4c4">
              <Button size="lg" className="w-full sm:w-auto gap-2" data-id="element-1521" data-mp="2rsshv7lnk3wq">
                <Heart className="w-5 h-5" data-id="element-1522" data-mp="2nt1joitsqli6" />
                Faire un don
              </Button>
            </Link>
            <Link to="/partner" data-id="element-1523" data-mp="xgc4lmufvpid">
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-white text-white hover:bg-white/10 hover:text-white gap-2" data-id="element-1524" data-mp="xhdqyngwnyfe">
                <Briefcase className="w-5 h-5" data-id="element-1525" data-mp="nbm8vypmphml" />
                Recruter un personnel
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}